import { array } from 'fp-ts';
import { constTrue, pipe } from 'fp-ts/lib/function';

export function areAllElementsNonNullable<T>(
  a: (T | null | undefined)[],
): a is T[] {
  return pipe(
    a,
    array.foldLeft(
      constTrue,
      (head, tail) =>
        head !== undefined && head !== null && areAllElementsNonNullable(tail),
    ),
  );
}
